import { useTypedQuery } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useUserDetailsQuery = (id: number | null) =>
  useTypedQuery({
    queryKey: UsersDashboardQueryKeys.details,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { id: id ?? -1 }, baseUrl)).data,
    enabled: Boolean(id)
  });
